import type { ReactNode } from 'react';

import { PositionRow } from '@/components/PositionRow';
import type { Position } from '@/types';

interface ActivePositionsTableProps {
	positions: Position[];
	header?: ReactNode;
}

export function ActivePositionsTable({ positions, header }: ActivePositionsTableProps) {
	return (
		<div className="card overflow-hidden">
			{header}
			<div className="overflow-x-auto">
				<table className="w-full">
					<thead>
						<tr className="border-b border-border">
							<th className="text-left py-2 px-4 text-sm font-medium text-text-muted">Symbol</th>
							<th className="text-left py-2 px-4 text-sm font-medium text-text-muted">Side</th>
							<th className="text-left py-2 px-4 text-sm font-medium text-text-muted">Size</th>
							<th className="text-left py-2 px-4 text-sm font-medium text-text-muted">
								Entry Price
							</th>
							<th className="text-left py-2 px-4 text-sm font-medium text-text-muted">
								Mark Price
							</th>
							<th className="text-left py-2 px-4 text-sm font-medium text-text-muted">Notional</th>
							<th className="text-left py-2 px-4 text-sm font-medium text-text-muted">
								Unrealized PnL
							</th>
							<th className="text-left py-2 px-4 text-sm font-medium text-text-muted">Stop Loss</th>
							<th className="text-left py-2 px-4 text-sm font-medium text-text-muted">
								Take Profit
							</th>
						</tr>
					</thead>
					<tbody>
						{positions.map((position) => (
							<PositionRow key={position.symbol} position={position} />
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
}
